import request from '@/router/axios'
// 产品分页
export function getProductList (query) {
  return request({
    url: '/api/product/page',
    method: 'get',
    params: query
  })
}
// 配件分页
export function getPartList (query) {
    return request({
      url: '/api/part/page',
      method: 'get',
      params: query
    })
}
// 辅料分页
export function getMaterialList (query) {
    return request({
      url: '/api/material/page',
      method: 'get',
      params: query
    })
}
// 产品筛选
export function getProductFilter (query) {
    return request({
      url: '/api/product/select/list',
      method: 'get',
      params: query
    })
}
// 配件筛选
export function getPartFilter (query) {
    return request({
      url: '/api/part/select/list',
      method: 'get',
      params: query
    })
}
// 辅料筛选
export function getMaterialFilter (query) {
    return request({
      url: '/api/material/select/list',
      method: 'get',
      params: query
    })
}
// 上传文件
export function uploadFile(obj) {
  return request({
    url: '/api/blade-resource/oss/endpoint/put-file',
    method: 'post',
    data: obj
  })
}
// 获取国家语言列表
export function getLanguageList (query) {
  return request({
    url: '/api/blade-system/tenant/list/ext',
    method: 'get',
    params: query
  })
}
// 获取价格列表
export function getPriceUnitList (query) {
  return request({
    url: '/api/price/list',
    method: 'get',
    params: query
  })
}
// 新增产品
export function addProduct(obj) {
  return request({
    url: '/api/product',
    method: 'post',
    data: obj
  })
}
// 新增配件
export function addParts(obj) {
  return request({
    url: '/api/part',
    method: 'post',
    data: obj
  })
}
// 新增辅料
export function addMaterial(obj) {
  return request({
    url: '/api/material',
    method: 'post',
    data: obj
  })
}
// 获取产品详情
export function getProductDetail (query) {
  return request({
    url: '/api/product/' + query,
    method: 'get',
  })
}
// 获取配件详情
export function getPartDetail (query) {
  return request({
    url: '/api/part/' + query,
    method: 'get',
  })
}
// 获取辅料详情
export function getMaterialDetail (query) {
  return request({
    url: '/api/material/' + query,
    method: 'get',
  })
}
// 删除产品
export function deleteProduct(id) {
  return request({
    url: '/api/product/' + id,
    method: 'delete',
  })
}
// 删除配件
export function deleteParts(id) {
  return request({
    url: '/api/part/' + id,
    method: 'delete',
  })
}
// 删除辅料
export function deleteMaterial(id) {
  return request({
    url: '/api/material/' + id,
    method: 'delete',
  })
}
// 编辑产品
export function editProduct(obj) {
  return request({
    url: '/api/product',
    method: 'put',
    data: obj
  })
}
// 编辑配件
export function editParts(obj) {
  return request({
    url: '/api/part',
    method: 'put',
    data: obj
  })
}
// 编辑辅料
export function editMaterial(obj) {
  return request({
    url: '/api/material',
    method: 'put',
    data: obj
  })
}

// 查看总代物料购物车数量
export function getGeneralItemShoppingNumber (query) {
  return request({
    url: '/api/generalItemShopping/number',
    method: 'get',
  })
}

// 新增总代物料购物车
export function addGeneralShopping(obj) {
  return request({
    url: '/api/generalItemShopping',
    method: 'post',
    data: obj
  })
}